/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'
import { Container } from './styles'

interface PDFProps {
  url: string
}

const PDFRenderer: React.FC<PDFProps> = ({ url }) => {
  return (
    <Container>
      <iframe src={url} frameBorder="0" />
      {/* <embed src="https://www.thecampusqdl.com/uploads/files/pdf_sample_2.pdf" /> */}
    </Container>
  )
}

export default PDFRenderer
